import { render } from "./ChangeDisplayCurrencyModal.vue?vue&type=template&id=132435fc"
import script from "./ChangeDisplayCurrencyModal.vue?vue&type=script&lang=js"
export * from "./ChangeDisplayCurrencyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__